// extracted by mini-css-extract-plugin
export default {"profile-social-list":"Detalle_profile-social-list__2as5z","value-strong":"Detalle_value-strong__+Nel-","value-emphasis":"Detalle_value-emphasis__e-QtD"};